import React, { ReactNode } from 'react';
import { useMediaQuery } from '@material-ui/core';
import background from './asset/background/background.webp';

interface LayoutProps {
    children: ReactNode;
    /**
     * Text pages (privacy, consent) are taller than the screen. With the fixed 100vh box below the bottom of the
     * text is cut off and cannot be reached on a phone, so those pages grow with their content and let the page
     * itself scroll. The game and video screens keep the fixed, non-scrolling box.
     */
    scrollable?: boolean;
}

const MobileLayout = ({ children, scrollable = false }: LayoutProps) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(max-width:1024px)');

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: scrollable ? 'flex-start' : 'center', /* Center content vertically */
            background: '#FFF5EE',
            height: scrollable ? 'auto' : '100dvh',
            minHeight: '100dvh',
            margin: 0, /* Ensure no default margins cause overflow */
            overflow: scrollable ? 'visible' : 'hidden'
        }}>
            <div
                className="content"
                style={{
                    width: isMobile ? '100%' : (isTablet ? '50%' : '30%'),
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover', // added
                    backgroundPosition: 'center', //added
                    height: scrollable ? 'auto' : '100dvh',
                    minHeight: scrollable ? '100dvh' : undefined,
                    /* Telefonens egne navigationsknapper må ikke ligge oven på indholdet */
                    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
                    overflowY: scrollable ? 'visible' : 'hidden',//changed from auto to hidden
                    overflowX: 'hidden',//added
                    boxSizing: 'border-box'//added
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default MobileLayout;
